



import CarpsaleHistoryListComponent from "@/components/admin/carpsaleHistory/carpsaleHistoryListComponent.vue";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "CarpsaleHistoryListPage",
  components: {
    CarpsaleHistoryListComponent,
  },
})
export default class CarpsaleHistoryListPage extends Vue {}
